/**
 * Meant to be a temporary, refactored copy of _fyh/src/components/shared/toggle.js
 * until FYH gets consolidated/refactored into the apps/ directory
 */
import React, { useState, useEffect } from 'react';
const Toggle = ({ toggleTitle, toggleTextTrue, toggleTextFalse, checked = false, renderSmall = false, className, onChange }) => {
    const [inputChecked, setInputChecked] = useState(false);
    useEffect(() => {
        setInputChecked(checked);
    }, [checked]);
    const handleChange = (e) => {
        setInputChecked(!inputChecked);
        if (onChange) {
            onChange(!inputChecked);
        }
    };
    const renderToggle = () => (React.createElement("label", { className: 'toggle' + (className ? ' ' + className : '') },
        React.createElement("input", { type: "checkbox", checked: inputChecked, onChange: handleChange }),
        inputChecked ? (React.createElement("span", { className: "toggle__slider toggle__slider--true" }, toggleTextTrue)) : (React.createElement("span", { className: "toggle__slider toggle__slider--false" }, toggleTextFalse))));
    const renderToggleSmall = () => (React.createElement("div", { className: 'toggle__flex' + (className ? ' ' + className : '') },
        React.createElement("p", { className: "toggle__title" }, toggleTitle),
        React.createElement("label", { className: 'toggle--small' + (inputChecked ? ' checked' : '') },
            React.createElement("span", { className: "sr-only" }, toggleTitle),
            React.createElement("input", { type: "checkbox", checked: inputChecked, onChange: handleChange }),
            React.createElement("span", { className: "toggle--small__slider" }))));
    return React.createElement(React.Fragment, null, renderSmall ? renderToggleSmall() : renderToggle());
};
export default Toggle;
